// AUTO-GENERATED by scripts/build-responsive-images.mjs — DO NOT EDIT BY HAND.
//
// Maps an original asset path to the variant widths that exist on disk as
// AVIF and WebP. <ResponsiveImage> consults this so it can never emit a
// <source srcset> pointing at a file that was not generated — a missing
// variant would render as a BROKEN IMAGE rather than falling through to the
// next source.
//
// To add a source: add it to scripts/build-responsive-images.mjs and re-run
// `npm run build:responsive-images`. No call site needs to change.

export const RESPONSIVE_IMAGE_VARIANTS: Record<string, number[]> = {
  "/assets/lifestyle/person-paperwork-with-dog.jpg": [400, 800],
  "/assets/planner/pet-care-planner-calendar.jpg": [240, 480, 720],
  "/assets/planner/pet-care-planner-collage.jpg": [640, 960, 1280, 1536],
  "/assets/planner/pet-care-planner-cover-page.jpg": [360, 540, 720, 1024],
  "/assets/planner/pet-care-planner-cover.jpg": [240, 480, 720],
  "/assets/planner/pet-care-planner-daily-checklist.jpg": [240, 480, 720],
  "/assets/planner/psd-workbook-cover.jpg": [240, 480, 720],
  "/assets/planner/psd-workbook-milestones.jpg": [240, 480, 720],
  "/assets/planner/psd-workbook-public-access.jpg": [240, 480, 720],
};

/** Variant widths available for `src`, or null when it has none. */
export function variantsFor(src: string): number[] | null {
  return RESPONSIVE_IMAGE_VARIANTS[src] ?? null;
}
